import $ from 'jquery';

const toggleUserPreference = () => {
    const $trigger = $('.js-trigger');
    if ($trigger.length === 0) return;

    $trigger.click(function () {
        const $el = $(this);
        $el.toggleClass('open');
        $el.closest('.js-s-location-and-status').find('.form-wrapper ').toggleClass('open');

        // close menu if opened
        if ($('.mobile-menu-is-active').length > 0) {
            $('.c-mobile-nav-trigger').click();
        }
    });
};

const bindRadioState = () => {
    const $input = $('.js-s-location-and-status input[type="radio"]');
    if ($input.length === 0) return;

    $input.change(function () {
        const $el = $(this);
        $(`.js-s-location-and-status input[name="${$el.attr('name')}"]`).parent().removeClass('checked');
        $el.parent().addClass($el.is(':checked') ? 'checked' : '');
    });
};

const initPersonalizationModal = () => {
    const $modals = $('.js-s-location-and-status.show-as-modal');
    const $modalTrigger = $('.js-open-personalization-modal');
    if ($modals.length === 0 || $modalTrigger.length === 0) return;

    $modalTrigger.each(function () {
        const $el = $(this);

        $(window).scroll(function () {
            if ($el.offset().top < ($(this).scrollTop() + window.innerHeight)) {
                $('.js-personalization-modal').click();
            }
        });
    });
};

$(() => {
    bindRadioState();
    toggleUserPreference();
    initPersonalizationModal();
});
